.a7{align-items:center;}